import React from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'
import PerformanceTable from './PerformanceTable'

const ActivityTable = props => {
  let [currentState] = useStateValue()
  let [tableOpen, setTableOpen] = React.useState(true)
  let handleClick = () => {
    setTableOpen(!tableOpen)
  }
  let title_header = 'title_column_header'
  let due_date_header = 'due_date_column_header'
  let perf_header = 'performance_column_header'
  let location_header = 'location_column_header'
  let tdStyle = { whiteSpace: 'normal', wordBreak: 'break-word' }
  return (
    <div>
      <h3
        className="mt-0 text-white p-3 rounded-top text-capitalize"
        style={{ backgroundColor: props.group.color }}
      >
        <i
          className={`fa-regular mr-3 fa-lg pointer ${
            tableOpen ? 'fa-angle-down' : 'fa-angle-right'
          }`}
          onClick={handleClick}
          tabIndex="0"
          role="button"
        />
        {props.group.title.replace('&#39;', "'")}
      </h3>
      {tableOpen ? (
        <div
          className="mb-5 p-3 rounded-bottom"
          style={{
            borderColor: props.group.color,
            border: `1px solid ${props.group.color}`,
            overflowX: 'auto',
          }}
        >
          <table
            className="table table-striped table-bordered"
            style={{ tableLayout: 'auto', wdith: '100%' }}
          >
            <thead>
              <tr>
                <th id={title_header}>Title</th>
                <th id={due_date_header}>Due Date</th>
                <th id={perf_header}>Performance</th>
                <th id={location_header}>Textbook Location</th>
              </tr>
            </thead>
            <tbody>
              {props.group.activities.map((act, i) => {
                return (
                  <tr key={i} data-activity-id={act[0]}>
                    <td
                      className="activity_title_cell"
                      headers={title_header}
                      style={tdStyle}
                    >
                      {act[5] ? (
                        <a
                          href={`/course/activity/${currentState.courseData.coursenum}/${act[0]}/`}
                          dangerouslySetInnerHTML={{ __html: act[1] }}
                        />
                      ) : (
                        <React.Fragment>
                          <div>{act[1]}</div>
                          <span className="pull-right">
                            <div className="icon icon_lock icon_color_orange" />
                          </span>
                        </React.Fragment>
                      )}
                    </td>
                    <td
                      className="activity_due_date_cell"
                      headers={due_date_header}
                      style={tdStyle}
                    >
                      {act[2]}
                    </td>
                    <td
                      className="activity_performance_cell"
                      headers={perf_header}
                      style={tdStyle}
                    >
                      <span className="activity_performance_cell_contents">
                        <PerformanceTable subs={act[3]} />
                      </span>
                    </td>
                    <td
                      className="activity_location_cell"
                      headers={location_header}
                      style={tdStyle}
                    >
                      {act[4] && (
                        <a href={act[4]}>
                          Go to{' '}
                          <span className="fa-solid fa-long-arrow-right fa-fw" />
                        </a>
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  )
}

export default ActivityTable

ActivityTable.propTypes = {
  group: PropTypes.object,
}
